<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header><h1 class="rb-ob-title">{{ $t('intake.letterVoiceTitle') }}</h1></header>
    <div class="rb-ob-status-panel">
      <p>{{ $t('intake.letterVoiceUnavailable') }}</p>
      <p>{{ $t('intake.letterVoiceOptional') }}</p>
    </div>
    <div class="rb-ob-actions">
      <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="backToOffer">{{ $t('intake.letterVoiceBack') }}</button>
    </div>
  </div>
</template>
<script>
export default {name:'MatchLetterVoiceStep',methods:{backToOffer(){this.$router.replace({name:'intakeLetter',params:{lang:this.$route.params.lang||'fa'},query:this.$route.query})}}}
</script>
